/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".clear-scope-btn[_ngcontent-%COMP%]{padding:.5rem .75rem;font-size:.875rem;color:#374151;border:1px solid #d1d5db;border-radius:.375rem;background-color:#fff;cursor:pointer;height:2.5rem;-webkit-transition:background-color .2s;transition:background-color .2s}.clear-scope-btn[_ngcontent-%COMP%]:hover{background-color:#f9fafb}"];
export { styles as styles };
